import { WORKSPACE } from 'constants/routes';
import { serviceRoles } from 'config/access';
import { checkAccess } from 'helpers/auth';
import WorkspacePage from './container/WorkspacePage';

export default function getWorkspacesRoute(userAuth) {
  const { account, reports } = serviceRoles;
  const requireAuth = {
    [account.name]: [
      account.roles.superadmin,
    ],
    [reports.name]: [
      reports.roles.reporter,
    ],
  };
  return {
    path: WORKSPACE,
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    withSidebar: true,
    withAppBar: true,
    component: WorkspacePage,
  };
}
